import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "angular-toastr/dist/angular-toastr.css";
import angular from "angular";
import uiRouter from "angular-ui-router";
import { rootComponent } from "./root.component";
import { app } from "./common/app.module";
import { components } from "./components/components.module";
import "angular-auto-validate/dist/jcs-auto-validate.min";
import ngResource from "angular-resource";
import toastr from "angular-toastr";
import transitionLoader from "angular-loading-bar";
import "angular-loading-bar/build/loading-bar.min.css";
import ngCookies from "angular-cookies";
import "./common/style/_reset.scss";
import "./common/style/_mixins.scss";
import "./common/style/_variables.scss";
import "./common/style/_common.scss";
import "./common/style/_font.scss";
import Constants from "./Constants";

angular.module("app.constant", []).constant("Constants", new Constants());

export const root = angular
  .module("root", [
    uiRouter,
    ngResource,
    app,
    components,
    "jcs-autoValidate",
    toastr,
    transitionLoader,
    ngCookies,
    "app.constant",
  ])
  .component("root", rootComponent)
  .config(
    (cfpLoadingBarProvider, $urlRouterProvider, $httpProvider, $provide) => {
      "ngInject";

      cfpLoadingBarProvider.includeSpinner = false;
      $urlRouterProvider.otherwise("home");
      $provide.factory("myHttpInterceptor", ($q, $injector) => {
        return {
          // optional method
          request: function (config) {
            // do something on success
            const AuthService = $injector.get("AuthService");
            config.headers.Authorization = AuthService.getAuthorizationHeader();
            return config;
          },

          // optional method
          requestError: function (rejection) {
            // do something on error

            return $q.reject(rejection);
          },
          response: function (response) {
            // do something on success
            return response || $q.when(response);
          },
          responseError: function (rejection) {
            // do something on error
            if (
              rejection.status === 401 ||
              rejection.status === 404 ||
              (rejection.status === 400 &&
                rejection.data.errors.message ===
                  "Token not found in Authorization Body or query param")
            ) {
              const AuthService = $injector.get("AuthService");
              AuthService.expireSession();
            }
            return $q.reject(rejection);
          },
        };
      });

      $httpProvider.defaults.headers.common["Cache-Control"] = "no-cache";
      $httpProvider.defaults.cache = false;
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get["If-Modified-Since"] = "0";
      $httpProvider.interceptors.push("myHttpInterceptor");
    }
  )
  // local
  //.constant("API_ENDPOINT", "http://localhost:4500/v1/cms")

  //staging
  .constant("API_ENDPOINT", "https://cmvr-staging-cms.infojiniconsulting.com/api")

  //Production
  // .constant("API_ENDPOINT", "https://cmvr-cms.infojiniconsulting.com/api")

  .run((defaultErrorMessageResolver) => {
    "ngInject";
    defaultErrorMessageResolver.getErrorMessages().then((errorMessages) => {
      errorMessages["dateRequired"] = "Please select date";
      errorMessages["invalidPasswordError"] =
        "Invalid password. Please match above mentioned pattern.";
      errorMessages["invalidVideoUrlError"] =
        "Please input a valid YouTube or Vimeo video URL";
      errorMessages["invalidImageSizeExceeds"] =
        "The max file upload size is of 10 mb";
      errorMessages["ngPatternError"] = "Please input a valid URL";
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/root.module.js